import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Badge = styled(motion.div)`
  position: relative;
  z-index: 2;
  height: 56px;
  border-radius: 28px;
  padding: 0 20px;
  background-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.confetti : theme.colors.fountain200};
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
  user-select: none;
  transition: 500ms;
  box-shadow: ${({ theme }) => theme.shadows.small};
  cursor: pointer;

  > svg {
    display: block;
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.black};
  }

  > span {
    font-weight: 700;
    font-size: 16px;
    line-height: 16px;
  }
`;

export const BadgeDescription = styled(motion.div)`
  background-color: ${th('colors.black')};
  overflow: hidden;
  margin-top: -28px;
  border-radius: 0px 0px 20px 20px;

  > p {
    margin: 0;
    padding: 48px 20px 30px 20px;
  }

  @media ${sizes.tabletLandscape} {
    display: none;
  }
`;
